import { AppDispatch } from "@Reducers/index";
import { setLayout, settleLayoutStatus } from "../reducers/layout";
import axiosWrapper from "../services/axiosWrapper";

/** Loads the portal's layout; `layoutStatus` leaves "pending" on the first answer, whichever it is. */
export function fetchLayout() {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await axiosWrapper.api.get("/portal/getLayoutData");
      if (response.data.status) {
        dispatch(setLayout(response.data.result));
        dispatch(settleLayoutStatus("loaded"));
      } else {
        dispatch(settleLayoutStatus("failed"));
      }
    } catch (error) {
      // Settled before rethrowing: a layout that never arrives must not keep the shell's search chip up.
      dispatch(settleLayoutStatus("failed"));
      throw error;
    }
  };
}
